import { BaseRepository } from './base';
import { Quote } from '../classes/quote';
import { CreateQuoteBody, Quote as QuoteData } from '../types/quote';

export class QuoteRepository extends BaseRepository {
  async create(args: CreateQuoteBody) {
    const quoteResponse = (await this.API.post('/quote', args)) as {
      quote: QuoteData;
    };
    return new Quote(quoteResponse.quote);
  }
}
